module.exports = __webpack_public_path__ + "static/img/qItem2-img1.6f270ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem2-img1.png
// module id = 3eSL
// module chunks = 1